import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { IVehicleTableData } from '@/types'

export const useVehicleStore = defineStore('vehicle', () => {
  const selectedVehicle = ref<IVehicleTableData | null>(null)

  const setSelectedVehicle = (vehicle: IVehicleTableData) => {
    selectedVehicle.value = vehicle
  }

  const clearSelectedVehicle = () => {
    selectedVehicle.value = null
  }

  return {
    selectedVehicle,
    setSelectedVehicle,
    clearSelectedVehicle,
  }
})
